module.exports = __webpack_public_path__ + "static/media/3.42a8239f.jpg";